import {Injectable} from '@angular/core';
import {Observable, from, OperatorFunction} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Filtro} from './filtro';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FiltrosService {

    constructor(private http: HttpClient) {
    }

    private baseUrl = environment.urlApi + '/api/filtros';

    public getFiltro(): Observable<Filtro> {
        return this.http.get<Filtro>(`${this.baseUrl}`).pipe(map(this.ordenarFiltro));
    }

    private ordenarFiltro(filtro: Filtro): Filtro {
        Object.keys(filtro[0]).filter(key => key !== 'id').forEach(key => {
            filtro[0][key] = filtro[0][key].sort((a: any, b: any) => {

                const descricao1 = a.descricao ? a.descricao : a.valor;
                const descricao2 = b.descricao ? b.descricao : b.valor;

                if (descricao1 > descricao2) {
                    return 1;
                } else if (descricao2 > descricao1) {
                    return -1;
                } else {
                    return 0;
                }

            });
        });

        return filtro;
    }

}
